// TODO: this code should be removed once the new ad stack code is written. This is a temporary solution to improve CLS
export const resizeAdPostRender = () => {
    const adContainer = document.querySelector('[data-resizeable-ad-container]');
    if (!adContainer) {
        return;
    }
    const adSlotObserver = new MutationObserver(() => {
        const iframe = adContainer.querySelector('iframe');
        if (iframe && iframe.offsetHeight < 600) {
            adContainer.classList.add('small');
        }
    });
    adSlotObserver.observe(adContainer, { childList: true, subtree: true });
};
